import {formatDecimal} from '../util/util';
import * as moment from 'moment';

export const pen = {
    inserted(el, binding) {
        if (typeof binding.value != 'undefined' && binding.value != null) {
            el.innerHTML = "S/ " + formatDecimal(binding.value);
        } else {
            el.innerHTML = null
        }

    },
    update(el, binding) {
        if (typeof binding.value != 'undefined' && binding.value != null) {
            el.innerHTML = "S/ " + formatDecimal(binding.value);
        } else {
            el.innerHTML = null
        }
    }
};

export const dateLocal = {
    inserted(el, binding) {
        if (binding.value) {
            el.innerHTML = moment(binding.value).format("DD/MM/YYYY");
        } else {
            el.innerHTML = null
        }

    },
    update(el, binding) {
        if (binding.value) {
            el.innerHTML = moment(binding.value).format("DD/MM/YYYY");
        } else {
            el.innerHTML = null
        }
    }
};


export const dateHour = {
    inserted(el, binding) {
        if (binding.value) {
            el.innerHTML = moment(binding.value).format("DD/MM/YYYY HH:mm");
        } else {
            el.innerHTML = null
        }

    },
    update(el, binding) {
        if (binding.value) {
            el.innerHTML = moment(binding.value).format("DD/MM/YYYY HH:mm");
        } else {
            el.innerHTML = null
        }
    }
};



// WEBPACK FOOTER //
// ./src/directives/currency.js